import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-progress-arc',
    templateUrl: './progress-arc.component.html',
    styleUrls: ['./progress-arc.component.scss']
})
export class ProgressArcComponent {
    @Input() progress: number = 0; // Progress percentage (0 to 100)

    getPath(): string {
        const progress = Math.min(99.9, this.progress);
        const radius = 8;
        const center = 8;
        const angle = (progress / 100) * 360;
        const radians = (angle - 90) * (Math.PI / 180); // Adjust for SVG rotation
        const x = center + radius * Math.cos(radians);
        const y = center + radius * Math.sin(radians);
        const largeArcFlag = this.progress > 50 ? 1 : 0;

        return `M ${center},${center} L ${center},${center - radius} A ${radius},${radius} 0 ${largeArcFlag},1 ${x},${y} Z`;
    }

    getProgress() {
        return Math.floor(this.progress);
    }
}
